import { createAnalyticsCardBaseProps } from '../pages/AnalyticsDashboard/utils/createAnalyticsCardBaseProps'
import { useAnalyticsReportBase } from './useAnalyticsReportBase'

type UseAnalyticsCardBaseParams = {
  reportId: string
  filters?: Record<string, string>
}

export const useAnalyticsCardBase = ({ reportId, filters }: UseAnalyticsCardBaseParams) => {
  const reportBase = useAnalyticsReportBase({ reportId, filters })
  const analyticsCardBaseProps = createAnalyticsCardBaseProps(reportBase)

  return {
    ...analyticsCardBaseProps,
    enabled: !!reportBase.reportDefinition,
    decorator: reportBase.reportDefinition?.decorator,
    reportData: reportBase.reportData,
    reportDefinition: reportBase.reportDefinition,
    activeColumn: reportBase.activeColumn,
  }
}
